import {attachVideoEvents, showVideoContent} from '../util/image';

const util = require('../../../utils/util');
const cookie = require('../../../components/cookie');

/**
 * If the youtube cookie is allowed we will load already cached youtube video content.
 *
 * @returns {void}
 */
export default () => {
    cookie.isAllowed('youtube', async isAllowed => {
        const youtubeContainer = $('.youtube-container');

        if (!isAllowed) {
            youtubeContainer.find('.disallowed-cookie').removeClass('m-hidden');
        }

        if (youtubeContainer && isAllowed) {
            const pid = youtubeContainer.data('pid');
            const pname = youtubeContainer.data('pname');

            if (pid && pname) {
                const params = {
                    pid,
                    pname,
                    format: 'ajax'
                };

                const url = util.appendParamsToUrl(Urls.getYoutubeContent, params);

                const videoResult = await fetch(url);

                const youtubeContent = await videoResult.text();

                if (youtubeContent) {
                    youtubeContainer.replaceWith(youtubeContent);

                    showVideoContent();
                    attachVideoEvents();
                    youtubeContainer.find('.disallowed-cookie').addClass('m-hidden');

                    const $productVideoThumbnail = $('.video-thumbnail');
                    const $youtubeThumbnail = $('.js-video-thumbnail-image');
                    if ($productVideoThumbnail.length > 0 && $youtubeThumbnail.length > 0) {
                        $productVideoThumbnail.attr('src', $youtubeThumbnail.attr('src'));
                    }
                }
            }
        }
    });
};
